import { render, staticRenderFns } from "./ShopClientTab.vue?vue&type=template&id=0c1274ee&scoped=true&"
import script from "./ShopClientTab.vue?vue&type=script&lang=js&"
export * from "./ShopClientTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1274ee",
  null
  
)

export default component.exports